import { Box, Chip, Typography } from '@mui/material';
import { BLUE, INTER, NAVY, POPPINS, YELLOW } from '../../studentStyles';

interface SpeakingHeroProps {
    label: string;
    hanzi: string;
    pinyin: string;
}

// The gradient header every "teacher speaks, then you speak" card opens with —
// the student-side echo of the teacher mockup's activity preview. Quiz, matching
// and reference cards stay flat so the two families read apart at a glance.
export default function SpeakingHero({ label, hanzi, pinyin }: SpeakingHeroProps) {
    return (
        <Box sx={{ p: 3, position: 'relative', overflow: 'hidden', background: `linear-gradient(135deg, ${NAVY} 0%, ${BLUE} 100%)` }}>
            <Box sx={{ position: 'absolute', width: 160, height: 160, borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.08)', right: -40, top: -60 }} />
            <Box sx={{ position: 'absolute', width: 90, height: 90, borderRadius: '50%', backgroundColor: `${YELLOW}38`, left: -25, bottom: -40 }} />
            <Chip
                label={label}
                size="small"
                sx={{ position: 'relative', fontFamily: INTER, fontWeight: 700, fontSize: 11, letterSpacing: '0.08em', color: '#fff', backgroundColor: 'rgba(255,255,255,0.16)' }}
            />
            <Typography sx={{ position: 'relative', fontFamily: POPPINS, fontWeight: 600, fontSize: 24, color: '#fff', mt: 1.75, lineHeight: 1.3 }}>
                {hanzi}
            </Typography>
            <Typography sx={{ position: 'relative', fontFamily: INTER, fontSize: 14, color: 'rgba(255,255,255,0.78)', mt: 0.5 }}>
                {pinyin}
            </Typography>
        </Box>
    );
}
